import Service from '../message-center-service';

// 获取消息未读数量
const getUnreadMessageNum = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    Service.getUnreadMessageNum(params).then(response => {
      if(response.code === '0') {
        commit('UPDATE_MESSAGE_UNREAD_NUM', response.data);
      }
      resolve(response);
    }, error => {
      reject(error.data);
    });
  });
};
export const actions = {
  getUnreadMessageNum
};
